import SVGWidget from "./svgwidget";


//The ConditionalStyle lens will change the style attribute on an element between one of many user-provided strings,
// depending on the value of its node. Each (specific) node value is mapped to a style to apply.
//Options:
//   data-se-node:"<node path>" determines the node that will be subscribed to
//   data-se-case_default:"<css style string>" (optional) the element's style will be set to this if no other case matches
//
//Options when attached to a boolean node:
//   data-se-case_true:"<css style string>"
//   data-se-case_false:"<css style string>"
//
//Options when attached to a number node:
//   data-se-case_-1:"<css style string>"
//   data-se-case_0:"<css style string>"
//   data-se-case_1:"<css style string>"
//   data-se-case_2:"<css style string>"
//   ...
//   data-se-case_100:"<css style string>"
//   ... (they are auto-generated)
//
// For non-decimal numbers like Infinity, use the standard javascript toString() method to find out what their case should be called.
//
// If multiple nodes are provided, it may be useful to set,
//   data-se-logic:"first|and|or|xor|nand|nor|nxor"
// "first" will act as a passthrough for the first node (ignoring the rest)
// all others will cast all nodes to boolean and then evaluate the given
// logical expression on them.
//
//Options when attached to a string node:
//   data-se-case_<stringValue>:"<css style string>"     when the node takes on <stringValue>, the element will have this style applied.
//Note: no spaces in <stringValue> !

export default class ConditionalStyle extends SVGWidget{
	constructor(nodeRoot,element){
		super(nodeRoot,element);

		this.readStyleOptions();

        this.logic = SVGWidget.readAttribute(element,"seLogic",'first');

		//This should always be the LAST thing that happens in the constructor!
    	//Subscribing to nodes will end up getting update called, so we
    	//better be ready.
		this.setupNodes();
	}

	//readStyleOptions will scan through all data attributes of the form
	// se-case_<...> and save them in a map for quick access later.
	readStyleOptions(){
		this.caseStylePairs = {};
		var prefix = 'seCase_';
		for (var name in this.element.dataset){
			if (name.substr(0,prefix.length) === prefix){
				var caseName = name.substr(prefix.length);
				var style = this.element.dataset[name];

				this.caseStylePairs[caseName] = style;
			}
		}
        this.element._initialStyle = this.element.getAttribute('style') + ';';
	}

	update(node){
		let value = null;

        if (this.logic === 'first'){
            value = node.getValue() ? node.getValue().toString() : '';
        } else { //boolean
            let fInvertResult = this.logic[0] === 'n';

            //trim leading n if there is one
            let gate = fInvertResult ? this.logic.slice(1) : this.logic;

            let self = this;
            let values = Object.keys(this.nodes).map(function(key){
                return !!self.nodes[key].getValue()
            }); //map all bools to values


            let result = false;
            switch (gate){
                case 'and': //every node is true
                    result = values.every(function(v){return v});
                break;
                case 'or':  //at least one node is true
                    result = values.some(function(v){return v});
                break;
                case 'xor': //xor checksum
                    result = values.reduce(function(a,v){return (a||v) && !(a&&v)});
                break;
            }

            if (fInvertResult) result = !result;
            value = result.toString();
        }

		var style = this.caseStylePairs[value];
		if (style){ //if we found the node's value in the caseStylePairs map
			this.element.style.cssText = this.element._initialStyle + style;
		}
		else { //no cases matched, so go to the default if one is set - otherwise change nothing
			var defaultStyle = this.caseStylePairs['default'];
			if (defaultStyle){
				this.element.style.cssText = this.element._initialStyle + defaultStyle;
			} else {
				return; //Do nothing if node value not found
			}
		}
	}
}
